import { Timeout } from '../../types'
import { GridStateX } from '../../types/mfc'
import { generateModalKey } from '../app-state/modals'
import { getFloaterState } from '../components/Hooks/useModal'
import { setLargePreview } from '../components/presentation/Grid/helpers'
import { ExploreCategory } from '../constants/enums'
import { FLOATING_PREVIEW } from '../constants/floaters'
import { pubSub } from './pubSub'
import { customStateWrapper, GRID_STATE } from './state'

type SetGridStateOptions = { immediate?: boolean }

const setGridState = customStateWrapper<GridStateX, SetGridStateOptions>(
    (_updates, { immediate = false } = {}) => {
        pubSub.GRID.emit('state', GRID_STATE.grid, immediate)
    },
)((updates) => {
    GRID_STATE.grid = { ...GRID_STATE.grid, ...updates }
})

const avatarInfoOpenTimers: Record<number, Timeout> = {}

const exploreScrollPositions = {
    [ExploreCategory.Popular]: 0,
    [ExploreCategory.Trending]: 0,
    [ExploreCategory.MissMFC]: 0,
    [ExploreCategory.NewModels]: 0,
    [ExploreCategory.GroupShows]: 0,
}

pubSub.USERS.on(
    'UPDATE:isPublicShow',
    ({ current: isPublicShow, id }: { current: boolean; id: number }) => {
        const largePreview = getFloaterState(
            generateModalKey(FLOATING_PREVIEW, id),
        )()
        if (
            !largePreview || // not open
            isPublicShow
        ) {
            return
        }

        setLargePreview(id, null, false, false)
    },
)

// pubSub.GRID.on('state', (data) => {
//     pubSub.GRID.emit(
//         `state::${data?.state?.centeredIndex}`,
//         data?.state?.centeredIndex,
//     )
// })

export const getGridStateSelector = (attribute: keyof typeof GRID_STATE.grid) =>
    GRID_STATE.grid[attribute]

export const temporaryGridState = {
    centeredIndex: 0,
    lists: {},
}

export const setCenteredIndexState = (centeredIndex) => {
    const currentCenteredIndex = temporaryGridState.centeredIndex //getGridState()?.centeredIndex

    if (centeredIndex === currentCenteredIndex) {
        return
    }

    if (currentCenteredIndex !== undefined) {
        pubSub.GRID.emit(`state::${currentCenteredIndex}`, null)
    }

    temporaryGridState.centeredIndex = centeredIndex

    pubSub.GRID.emit(`state::${centeredIndex}`, centeredIndex)

    // setGridState({ modifications: { centeredIndex } })
}

export const resetCenteredIndexState = () => {
    temporaryGridState.centeredIndex = 0
}

export const clearAvatarInfoOpenTimer = (id: number) => {
    clearTimeout(avatarInfoOpenTimers[id])
    // eslint-disable-next-line fp/no-delete
    delete avatarInfoOpenTimers[id]
}

const clearAllAvatarInfoOpenTimers = () => {
    Object.keys(avatarInfoOpenTimers).forEach((id) =>
        clearAvatarInfoOpenTimer(Number(id)),
    )
}

const setAvatarInfoOpenIDState = (avatarInfoOpenID: number | null) => {
    setGridState({ avatarInfoOpenID })
}

export const resetAvatarInfoOpenIDState = () => {
    clearAllAvatarInfoOpenTimers()
    setAvatarInfoOpenIDState(null)
}

export const setAvatarInfoOpenID = (id: number | null) => {
    clearAllAvatarInfoOpenTimers()
    setAvatarInfoOpenIDState(id)
}

export const clearAvatarInfoOpenID = (id: number) => {
    // this is a hack to prevent the avatar info from closing when the list
    // refreshes (due to the tile unmounting and remounting in the current
    // implementation)
    avatarInfoOpenTimers[id] = setTimeout(() => {
        if (getGridStateSelector('avatarInfoOpenID') === id) {
            resetAvatarInfoOpenIDState()
        } else {
            clearAvatarInfoOpenTimer(id)
        }
    }, 1000)
}

export const setExploreScrollPosition = (
    category: ExploreCategory,
    scrollPosition: number,
) => {
    exploreScrollPositions[category] = scrollPosition
}

export const getExploreScrollPosition = (category: ExploreCategory) =>
    exploreScrollPositions[category]

export const resetExploreScrollPositions = () => {
    Object.keys(exploreScrollPositions).forEach((key) => {
        exploreScrollPositions[key] = 0
    })
}
